export default "__VITE_ASSET__CSS_09Yf__"